/**
  Author - Brijesh Pandey
  Git - https://github.com/brijesh-pandey/
**/

import {WealthyEnv} from "helpers";

const navLinks = [
  {
    url: `${WealthyEnv.URL}`,
    pathname: "/",
    text: "HOMEPAGE",
    loginUrl: WealthyEnv.BUILDWEALTH_APP_URL,
    downloadUrl: `${WealthyEnv.WEALTHY_PARTNERS_APP_LINK}`,
    adjacentLink: {
      url: `${WealthyEnv.URL}/investor`,
      text: "FOR INVESTORS"
    },
    subLinks: [
      {
        url: `${WealthyEnv.URL}`,
        text: "Home",
        pathname: "/",
        isMainNav: true
      },
      {
        url: `${WealthyEnv.URL}/partner/about-us`,
        text: "About Us",
        pathname: "/partner/about-us",
        isMainNav: true
      },
      {
        url: `${WealthyEnv.URL}/partner/calculators`,
        text: "Calculators",
        pathname: "/partner/calculators",
        isMainNav: true
      },
      {
        url: `${WealthyEnv.URL}/media`,
        text: "Media",
        pathname: "/media",
        isMainNav: true
      }
    ]
  },
  // For Investors
  {
    url: `${WealthyEnv.URL}/investor`,
    pathname: "/investor",
    text: "INVESTORS",
    loginUrl: `${WealthyEnv.APP_URL}`,
    downloadUrl: `${WealthyEnv.APP_DOWNLOAD_ONE_LINK}`,
    adjacentLink: {
      url: `${WealthyEnv.URL}/partner`,
      text: "JOIN AS PARTNER"
    },
    subLinks: [
      {
        url: `${WealthyEnv.URL}/investor`,
        text: "Home",
        pathname: "/investor",
        isMainNav: true
      },
      {
        text: "Our Solutions",
        isMainNav: true,
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/investor/mf-solutions`,
            text: "Mutual Fund",
            pathname: "/investor/mf-solutions",
            icon: "https://i.wlycdn.com/wealthy-home-page/mutual-funds-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/investor/insurance-solutions`,
            text: "Insurance",
            pathname: "/investor/insurance-solutions",
            icon: "https://i.wlycdn.com/wealthy-home-page/insurance-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/investor/broking-solutions`,
            text: "Broking",
            pathname: "/investor/broking-solutions",
            icon: "https://i.wlycdn.com/wealthy-home-page/stocks-icon-header.jpg"
          }
        ]
      },
      {
        text: "Insights",
        isMainNav: true,
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/blogs`,
            text: "Blogs",
            pathname: "/blogs",
            icon: "https://i.wlycdn.com/wealthy-home-page/blogs-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/newsletter/money-order`,
            text: "Newsletters",
            pathname: "/newsletter/money-order",
            icon: "https://i.wlycdn.com/wealthy-home-page/newsletter-icon-header.jpg"
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/investor/about-us`,
        text: "About Us",
        pathname: "/investor/about-us",
        isMainNav: true
      },
      {
        text: "Invest",
        isMainNav: true,
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/invest/stocks`,
            text: "Stocks",
            pathname: "/invest/stocks",
            icon: "https://i.wlycdn.com/wealthy-home-page/stocks-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/invest/mutual-funds`,
            text: "Mutual Funds",
            pathname: "/invest/mutual-funds",
            icon: "https://i.wlycdn.com/wealthy-home-page/mutual-funds-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/invest/ipo`,
            text: "IPO",
            pathname: "/invest/ipo",
            icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-ipo-icon.svg`
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/pricing`,
        text: "Pricing",
        pathname: "/pricing",
        isMainNav: true
      },
      {
        url: `${WealthyEnv.URL}/nri-investment-options-india/`,
        text: "For NRIs",
        pathname: "/nri-investment-options-india/",
        isMainNav: true
      }


      // {
      //   url: `${WealthyEnv.URL}/investor/support`,
      //   text: "Support",
      //   pathname: "/investor/support",
      //   isMainNav: true
      // }
    ]
  },
  // For Mutual Fund Distributors (Partners)
  {
    url: `${WealthyEnv.URL}/partner`,
    pathname: "/partner",
    text: "PARTNERS",
    loginUrl: WealthyEnv.BUILDWEALTH_APP_URL,
    downloadUrl: `${WealthyEnv.WEALTHY_PARTNERS_APP_LINK}`,
    adjacentLink: {
      url: `${WealthyEnv.URL}/investor`,
      text: "FOR INVESTORS"
    },
    subLinks: [
      {
        url: `${WealthyEnv.URL}/partner`,
        text: "Home",
        pathname: "/partner",
        isMainNav: true
      },
      {
        text: "Our Solutions",
        isMainNav: true,
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/partner/mf-solutions`,
            text: "Mutual Fund",
            pathname: "/partner/mf-solutions",
            icon: "https://i.wlycdn.com/wealthy-home-page/mutual-funds-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/partner/insurance-solutions`,
            text: "Insurance",
            pathname: "/partner/insurance-solutions",
            icon: "https://i.wlycdn.com/wealthy-home-page/insurance-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/partner/broking-solutions`,
            text: "Broking",
            pathname: "/partner/broking-solutions",
            icon: "https://i.wlycdn.com/wealthy-home-page/stocks-icon-header.jpg"
          }
        ]
      },
      {
        text: "Insights",
        isMainNav: true,
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/partner-desk/partner-blog/`,
            text: "Blogs",
            pathname: "/partner-desk/partner-blog",
            icon: "https://i.wlycdn.com/wealthy-home-page/blogs-icon-header.jpg"
          },
          {
            url: `${WealthyEnv.URL}/newsletter/`,
            text: "Newsletters",
            pathname: "/newsletter",
            icon: "https://i.wlycdn.com/wealthy-home-page/newsletter-icon-header.jpg"
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/partner/about-us`,
        text: "About Us",
        pathname: "/partner/about-us",
        isMainNav: true
      },
      {
        url: `${WealthyEnv.URL}/partner/calculators`,
        text: "Calculators",
        pathname: "/partner/calculators",
        isMainNav: true
      },
      {
        url: `${WealthyEnv.URL}/media`,
        text: "Media",
        pathname: "/media",
        isMainNav: true
      },

      // {
      //   url: `${WealthyEnv.URL}/partner/support`,
      //   text: "Support",
      //   pathname: "/partner/support",
      //   isMainNav: true
      // }
    ]
  },
  // Legacy entries for backward compatibility - can be removed if not needed
  {
    url: `${WealthyEnv.URL}/mutual-fund-distributor`,
    pathname: "/mutual-fund-distributor",
    text: "Mutual Fund Distributor",
    loginUrlFromPartners: WealthyEnv.BUILDWEALTH_APP_URL
  },
  {
    url: `${WealthyEnv.URL}/private-wealth-partner`,
    pathname: "/private-wealth-partner",
    text: "Private Wealth Partner",
    subLinks: [
      {
        url: `${WealthyEnv.URL}/about-us`,
        text: "About Us",
        pathname: "/about-us",
        style: {marginLeft: "-20rem"}
      },
      {
        url: `${WealthyEnv.URL}`,
        text: "For clients",
        pathname: "/",
        style: {color: "#ff9899", marginLeft: "-10rem"}
      }
    ]
  }
];

export default navLinks;
